import { element } from 'protractor';
import {
  Component,
  Input,
  ElementRef,
  forwardRef,
  Renderer2,
  HostListener,
  ChangeDetectorRef,
  ViewChild,
  TemplateRef,
  HostBinding, OnInit
} from '@angular/core';
import * as moment from 'moment';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DropDownAnimation} from '../select/dropdown-animations';
import { TagAnimation } from '../select/tag-animations';
@Component({
  selector: 'ant-daterangepicker',
  template:`<div style="position:relative;display:inline-block;" [class]="_size">
  <div class="ant-input-content" [style.width]="_width" (mouseenter)="removeBtn()" (mouseleave)="_isRemoveBtn=true">
    <input type="text"  class="ant-input ant-input-default " readonly [@tagAnimation] [value]="_result?_result:''" 
    [placeholder]='_placeholder' (click)="init()">
    <span class="ant-input-clear" (click)="remove()" [@tagAnimation] [hidden]="_isRemoveBtn"></span>
  </div>
  <div class="container" [@dropDownAnimation]="'top'" [hidden]="!_isDatepickerHide" >
    <div class="ant-result">
      <div [hidden]="_startDate?.title" style="font-size:12px;color:#aaa;line-height:28px;">请选择一个日期范围</div>
      <div [hidden]="!_startDate?.title">
        <span class="ant-result-header">已选择：</span>
        <span class="ant-startDate">{{_startDate?.title}}</span>
        <span [hidden]="!_startDate?.title">~</span>
        <span class="ant-endDate">{{_endDate?.title}}</span>
        <span [hidden]="_endDate?.title == '...' || !_endDate?.title">({{DateDiff(_startDate?.title, _endDate?.title)}}天)</span>
      </div>
      <button nz-button [nzType]="_btnType" style="text-align:right;" (click)="confirmBtn()">
          <span>确定</span>
      </button>
    </div>  
    <div class="ant-calendar-date-panel ant-container">
      <div class="ant-datepicker">
        <div class="ant-calendar-header" style="border-bottom:none;">
          <div class="ant-calendar-month-panel-body">
            <div style="position: relative;width:170px;">
              <!-- <a class="ant-calendar-prev-year-btn"></a> -->
              <a class="ant-calendar-prev-month-btn" style="left:12px;" (click)="_preMonth()"></a>
              <span class="ant-calendar-ym-select">
                <a class="ant-calendar-year-select">{{_showYear}}年</a>
                <a class="ant-calendar-month-select">{{_showMonth + 1}}月</a>
              </span>
              <a  style="right:12px;" (click)="_nextMonth()" [class.ant-calendar-next-month-btn]="(_showMonth!=11)?((_showMonth+1) != _showLastMonth || _showYear != _showLastYear):(_showYear+1 != _showLastYear || _showLastMonth != 0)"></a>
              <!-- <a class="ant-calendar-next-year-btn"></a> -->
            </div>
          </div>
        </div>
        <ant-datepicker #datepickerData [nzValue]="nowMonth" [nzShowMonth]="_showMonth" [nzShowYear]="_showYear" (nzClickDay)="clickDay($event)" (nzMouseDay)="mouseDay($event)"></ant-datepicker>
      </div>
      <div class="ant-middle-bg ant-hidden-bg" [class.ant-show-bg]="(_showMonth!=11)?((_showMonth+1) != _showLastMonth || _showYear != _showLastYear):(_showYear+1 != _showLastYear || _showLastMonth != 0)">
          <div class="gap-line">
            <div class="gap-1"></div>
            <div class="gap-2"></div>
            <div class="gap-3"></div>
          </div>
          <div class="gap-line">
              <div class="gap-1"></div>
              <div class="gap-2"></div>
              <div class="gap-3"></div>
          </div>
          <div class="gap-line">
              <div class="gap-1"></div>
              <div class="gap-2"></div>
              <div class="gap-3"></div>
          </div>
          <div class="gap-line">
              <div class="gap-1"></div>
              <div class="gap-2"></div>
              <div class="gap-3"></div>
          </div>
          <div class="gap-line">
              <div class="gap-1"></div>
              <div class="gap-2"></div>
              <div class="gap-3"></div>
            </div>
            <div class="gap-line">
                <div class="gap-1"></div>
                <div class="gap-2"></div>
                <div class="gap-3"></div>
            </div>
            <div class="gap-line">
                <div class="gap-1"></div>
                <div class="gap-2"></div>
                <div class="gap-3"></div>
            </div>
            <div class="gap-line">
                <div class="gap-1"></div>
                <div class="gap-2"></div>
                <div class="gap-3"></div>
            </div>
            <div class="gap-line">
                <div class="gap-1"></div>
                <div class="gap-2"></div>
                <div class="gap-3"></div>
              </div>
              <div class="gap-line">
                  <div class="gap-1"></div>
                  <div class="gap-2"></div>
                  <div class="gap-3"></div>
              </div>
              <div class="gap-line">
                  <div class="gap-1"></div>
                  <div class="gap-2"></div>
                  <div class="gap-3"></div>
              </div>
              <div class="gap-line">
                  <div class="gap-1"></div>
                  <div class="gap-2"></div>
                  <div class="gap-3"></div>
              </div>
              <div class="gap-line">
                  <div class="gap-1"></div>
                  <div class="gap-2"></div>
                  <div class="gap-3"></div>
              </div>
              <div class="gap-line">
                  <div class="gap-1"></div>
                  <div class="gap-2"></div>
                  <div class="gap-3"></div>
              </div>
      </div>
      <div class="ant-datepicker">
        <div class="ant-calendar-header" style="border-bottom:none;">
          <div class="ant-calendar-month-panel-body">
            <div style="position: relative;width:170px;">
              <!-- <a class="ant-calendar-prev-year-btn"></a> -->
              <a style="left:12px;" (click)="_preLastMonth()" [class.ant-calendar-prev-month-btn]="(_showMonth!=11)?((_showMonth+1) != _showLastMonth || _showYear != _showLastYear):(_showYear+1 != _showLastYear || _showLastMonth != 0)"></a>
              <span class="ant-calendar-ym-select">
                <a class="ant-calendar-year-select">{{_showLastYear}}年</a>
                <a class="ant-calendar-month-select">{{_showLastMonth + 1}}月</a>
              </span>
              <a class="ant-calendar-next-month-btn" style="right:12px;" (click)="_nextLastMonth()"></a>
              <!-- <a class="ant-calendar-next-year-btn"></a> -->
            </div>
          </div>
        </div>
        <ant-datepicker #datepickerDataLast [nzValue]="nextMonth" [nzShowMonth]="_showLastMonth" [nzShowYear]="_showLastYear" (nzClickDay)="clickDay($event)" (nzMouseDay)="mouseDay($event)"></ant-datepicker>
      </div>
    </div>
    <div class="ant-footer" *ngIf="_shortcuts || _customShortcuts">
      <span class="ant-footer-title">快捷选择</span>
      <div class="ant-footer-cell" *ngFor="let item of _shortcuts" >
        <span class="ant-footer-cell-title">{{item.title}}</span>
        <a *ngFor="let cell of item.datas" class="ant-footer-cell-content" (click)="shortcutOption(cell, item.tag)">{{cell | filterData}}</a>
      </div>
      <a *ngFor="let shortcut of _customShortcuts" class="ant-footer-cell-content" (click)="shortcutOption(shortcut)">{{shortcut | filterData}}</a>
    </div>
  </div>
</div>
`,
  styles: [`::ng-deep .ant-btn-group {
  position: relative;
  display: inline-block;
  font-size: 0px;
}
::ng-deep .ant-btn-group > .ant-btn {
  position: relative;
  z-index: 1;
}
::ng-deep .ant-btn-group > .ant-btn:hover,
::ng-deep .ant-btn-group > .ant-btn:focus,
::ng-deep .ant-btn-group > .ant-btn:active,
::ng-deep .ant-btn-group > .ant-btn.active {
  z-index: 2;
}
::ng-deep .ant-btn-group > .ant-btn:disabled {
  z-index: 0;
}
::ng-deep .ant-btn-group-lg > .ant-btn {
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  height: 32px;
}
::ng-deep .ant-btn-group-sm > .ant-btn {
  padding: 0 7px;
  font-size: 12px;
  border-radius: 4px;
  height: 22px;
}
::ng-deep .ant-btn-group-sm > .ant-btn > .anticon {
  font-size: 12px;
}
::ng-deep .ant-btn-group ant-button .ant-btn + ant-button .ant-btn,
ant-button .ant-btn + ::ng-deep .ant-btn-group,
::ng-deep .ant-btn-group ant-button + .ant-btn,
::ng-deep .ant-btn-group ant-button + ::ng-deep .ant-btn-group ant-button {
  margin-left: -1px;
}
::ng-deep .ant-btn-group ant-button {
  box-sizing: border-box;
}
::ng-deep .ant-btn-group ant-button:not(:first-child):not(:last-child) .ant-btn {
  border-radius: 0;
  padding-left: 8px;
  padding-right: 8px;
}
::ng-deep .ant-btn-group ant-button:first-child:not(:last-child) > .ant-btn {
  margin-left: 0;
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  padding-right: 8px;
}
::ng-deep .ant-btn-group ant-button:last-child:not(:first-child) > .ant-btn {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  padding-left: 8px;
}
::ng-deep .ant-btn-group ::ng-deep .ant-btn-group {
  float: left;
}
::ng-deep .ant-btn-group ::ng-deep .ant-btn-group:not(:first-child):not(:last-child) .ant-btn {
  border-radius: 0;
}
::ng-deep .ant-btn-group ::ng-deep .ant-btn-group:first-child:not(:last-child) > .ant-btn:last-child {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
  padding-right: 8px;
}
::ng-deep .ant-btn-group ::ng-deep .ant-btn-group:last-child:not(:first-child) .ant-btn:first-child {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
  padding-left: 8px;
}
@keyframes buttonEffect {
  to {
    opacity: 0;
    top: -6px;
    left: -6px;
    bottom: -6px;
    right: -6px;
    border-width: 6px;
  }
}
.ant-calendar-picker-container {
  position: absolute;
  z-index: 1050;
}
.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topLeft,
.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-topRight,
.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topLeft,
.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-topRight {
  animation-name: antSlideDownIn;
}
.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomLeft,
.ant-calendar-picker-container.slide-up-enter.slide-up-enter-active.ant-calendar-picker-container-placement-bottomRight,
.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomLeft,
.ant-calendar-picker-container.slide-up-appear.slide-up-appear-active.ant-calendar-picker-container-placement-bottomRight {
  animation-name: antSlideUpIn;
}
.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topLeft,
.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-topRight {
  animation-name: antSlideDownOut;
}
.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomLeft,
.ant-calendar-picker-container.slide-up-leave.slide-up-leave-active.ant-calendar-picker-container-placement-bottomRight {
  animation-name: antSlideUpOut;
}
.ant-calendar-picker {
  position: relative;
  display: inline-block;
  outline: none;
  font-size: 12px;
  transition: opacity 0.3s;
}
.ant-calendar-picker-input {
  outline: none;
  display: block;
}
.ant-calendar-picker:hover .ant-calendar-picker-input:not(.ant-input-disabled) {
  border-color: #108ee9;
}
.ant-calendar-picker-clear,
.ant-calendar-picker-icon {
  position: absolute;
  width: 14px;
  height: 14px;
  right: 8px;
  top: 50%;
  margin-top: -7px;
  line-height: 14px;
  font-size: 12px;
  transition: all .3s;
  user-select: none;
}
.ant-calendar-picker-clear {
  opacity: 0;
  z-index: 1;
  color: rgba(0, 0, 0, 0.25);
  background: #fff;
  pointer-events: none;
  cursor: pointer;
}
.ant-calendar-picker-clear:hover {
  color: rgba(0, 0, 0, 0.43);
}
.ant-calendar-picker:hover .ant-calendar-picker-clear {
  opacity: 1;
  pointer-events: auto;
}
.ant-calendar-picker-icon {
  color: rgba(0, 0, 0, 0.43);
}
.ant-calendar-picker-icon:after {
  content: "\\e6bb";
  font-family: "anticon";
  font-size: 12px;
  color: rgba(0, 0, 0, 0.43);
  display: inline-block;
  line-height: 1;
}
.ant-calendar {
  position: relative;
  outline: none;
  width: 231px;
  border: 1px solid #fff;
  list-style: none;
  font-size: 12px;
  text-align: left;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  line-height: 1.5;
}
.ant-calendar-input-wrap {
  height: 34px;
  padding: 6px;
  border-bottom: 1px solid #e9e9e9;
}
.ant-calendar-input {
  border: 0;
  width: 100%;
  cursor: auto;
  outline: 0;
  height: 22px;
  color: rgba(0, 0, 0, 0.65);
  background: #fff;
}
.ant-calendar-input::-moz-placeholder {
  color: rgba(0, 0, 0, 0.25);
  opacity: 1;
}
.ant-calendar-input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-calendar-input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-calendar-week-number {
  width: 286px;
}
.ant-calendar-week-number-cell {
  text-align: center;
}
.ant-calendar-header {
  height: 34px;
  line-height: 34px;
  text-align: center;
  user-select: none;
  border-bottom: 1px solid #e9e9e9;
}
.ant-calendar-header a:hover {
  color: #49a9ee;
}
.ant-calendar-header .ant-calendar-century-select,
.ant-calendar-header .ant-calendar-decade-select,
.ant-calendar-header .ant-calendar-year-select,
.ant-calendar-header .ant-calendar-month-select {
  padding: 0 2px;
  font-weight: bold;
  display: inline-block;
  color: rgba(0, 0, 0, 0.65);
  line-height: 34px;
}
.ant-calendar-header .ant-calendar-century-select-arrow,
.ant-calendar-header .ant-calendar-decade-select-arrow,
.ant-calendar-header .ant-calendar-year-select-arrow,
.ant-calendar-header .ant-calendar-month-select-arrow {
  display: none;
}
.ant-calendar-header .ant-calendar-prev-century-btn,
.ant-calendar-header .ant-calendar-next-century-btn,
.ant-calendar-header .ant-calendar-prev-decade-btn,
.ant-calendar-header .ant-calendar-next-decade-btn,
.ant-calendar-header .ant-calendar-prev-month-btn,
.ant-calendar-header .ant-calendar-next-month-btn,
.ant-calendar-header .ant-calendar-prev-year-btn,
.ant-calendar-header .ant-calendar-next-year-btn {
  position: absolute;
  top: 0;
  color: rgba(0, 0, 0, 0.43);
  font-family: Arial, "Hiragino Sans GB", "Microsoft Yahei", "Microsoft Sans Serif", sans-serif;
  padding: 0 5px;
  font-size: 16px;
  display: inline-block;
  line-height: 34px;
}
.ant-calendar-header .ant-calendar-prev-century-btn,
.ant-calendar-header .ant-calendar-prev-decade-btn,
.ant-calendar-header .ant-calendar-prev-year-btn {
  left: 7px;
}
.ant-calendar-header .ant-calendar-prev-century-btn:after,
.ant-calendar-header .ant-calendar-prev-decade-btn:after,
.ant-calendar-header .ant-calendar-prev-year-btn:after {
  content: '«';
}
.ant-calendar-header .ant-calendar-next-century-btn,
.ant-calendar-header .ant-calendar-next-decade-btn,
.ant-calendar-header .ant-calendar-next-year-btn {
  right: 7px;
}
.ant-calendar-header .ant-calendar-next-century-btn:after,
.ant-calendar-header .ant-calendar-next-decade-btn:after,
.ant-calendar-header .ant-calendar-next-year-btn:after {
  content: '»';
}
.ant-calendar-header .ant-calendar-prev-month-btn {
  left: 29px;
}
.ant-calendar-header .ant-calendar-prev-month-btn:after {
  content: '‹';
}
.ant-calendar-header .ant-calendar-next-month-btn {
  right: 29px;
}
.ant-calendar-header .ant-calendar-next-month-btn:after {
  content: '›';
}
.ant-calendar-body {
  padding: 4px 8px;
}
.ant-calendar table {
  border-collapse: collapse;
  max-width: 100%;
  background-color: transparent;
  width: 100%;
}
.ant-calendar table,
.ant-calendar th,
.ant-calendar td {
  border: 0;
}
.ant-calendar-calendar-table {
  border-spacing: 0;
  margin-bottom: 0;
}
.ant-calendar-column-header {
  line-height: 18px;
  width: 33px;
  padding: 6px 0;
  text-align: center;
}
.ant-calendar-column-header .ant-calendar-column-header-inner {
  display: block;
  font-weight: normal;
}
.ant-calendar-week-number-header .ant-calendar-column-header-inner {
  display: none;
}
.ant-calendar-cell {
  padding: 4px 0;
}
.ant-calendar-date {
  display: block;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.65);
  border-radius: 2px;
  width: 20px;
  height: 20px;
  line-height: 18px;
  border: 1px solid transparent;
  padding: 0;
  background: transparent;
  text-align: center;
  transition: background 0.3s ease;
}
.ant-calendar-date-panel {
  position: relative;
}
.ant-calendar-date:hover {
  background: #ecf6fd;
  cursor: pointer;
}
.ant-calendar-date:active {
  color: #fff;
  background: #49a9ee;
}
.ant-calendar-today .ant-calendar-date {
  border-color: #108ee9;
  font-weight: bold;
  color: #108ee9;
}
.ant-calendar-last-month-cell .ant-calendar-date,
.ant-calendar-next-month-btn-day .ant-calendar-date {
  color: rgba(0, 0, 0, 0.25);
}
.ant-calendar-selected-day .ant-calendar-date {
  background: #108ee9;
  color: #fff;
  border: 1px solid transparent;
}
.ant-calendar-selected-day .ant-calendar-date:hover {
  background: #108ee9;
}
.ant-calendar-disabled-cell .ant-calendar-date {
  cursor: not-allowed;
  color: #bcbcbc;
  background: #f7f7f7;
  border-radius: 0;
  width: auto;
  border: 1px solid transparent;
}
.ant-calendar-disabled-cell .ant-calendar-date:hover {
  background: #f7f7f7;
}
.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date {
  position: relative;
  margin-right: 5px;
  padding-left: 5px;
}
.ant-calendar-disabled-cell.ant-calendar-today .ant-calendar-date:before {
  content: " ";
  position: absolute;
  top: -1px;
  left: 5px;
  width: 20px;
  height: 20px;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
}
.ant-calendar-disabled-cell-first-of-row .ant-calendar-date {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.ant-calendar-disabled-cell-last-of-row .ant-calendar-date {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.ant-calendar-footer {
  border-top: 1px solid #e9e9e9;
  line-height: 38px;
  padding: 0 12px;
}
.ant-calendar-footer:empty {
  border-top: 0;
}
.ant-calendar-footer-btn {
  text-align: center;
  display: block;
}
.ant-calendar-footer-extra + .ant-calendar-footer-btn {
  border-top: 1px solid #e9e9e9;
  margin: 0 -12px;
  padding: 0 12px;
}
.ant-calendar .ant-calendar-today-btn,
.ant-calendar .ant-calendar-clear-btn {
  display: inline-block;
  text-align: center;
  margin: 0 0 0 8px;
}
.ant-calendar .ant-calendar-today-btn-disabled,
.ant-calendar .ant-calendar-clear-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
  cursor: not-allowed;
}
.ant-calendar .ant-calendar-today-btn:only-child,
.ant-calendar .ant-calendar-clear-btn:only-child {
  margin: 0;
}
.ant-calendar .ant-calendar-clear-btn {
  display: none;
  position: absolute;
  right: 5px;
  text-indent: -76px;
  overflow: hidden;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  top: 7px;
  margin: 0;
}
.ant-calendar .ant-calendar-clear-btn:after {
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\e62e";
  font-size: 12px;
  color: rgba(0, 0, 0, 0.25);
  display: inline-block;
  line-height: 1;
  width: 20px;
  text-indent: 43px;
  transition: color 0.3s ease;
}
.ant-calendar .ant-calendar-clear-btn:hover:after {
  color: rgba(0, 0, 0, 0.43);
}
.ant-calendar .ant-calendar-ok-btn {
  display: inline-block;
  margin-bottom: 0;
  font-weight: 500;
  text-align: center;
  touch-action: manipulation;
  cursor: pointer;
  background-image: none;
  border: 1px solid transparent;
  white-space: nowrap;
  padding: 0 15px;
  height: 28px;
  user-select: none;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  position: relative;
  color: #fff;
  background-color: #108ee9;
  border-color: #108ee9;
  padding: 0 7px;
  font-size: 12px;
  border-radius: 4px;
  height: 22px;
  line-height: 1.5;
}
.ant-calendar .ant-calendar-ok-btn > .anticon {
  line-height: 1;
}
.ant-calendar .ant-calendar-ok-btn,
.ant-calendar .ant-calendar-ok-btn:active,
.ant-calendar .ant-calendar-ok-btn:focus {
  outline: 0;
}
.ant-calendar .ant-calendar-ok-btn:not([disabled]):hover {
  text-decoration: none;
}
.ant-calendar .ant-calendar-ok-btn:not([disabled]):active {
  outline: 0;
  transition: none;
}
.ant-calendar .ant-calendar-ok-btn.disabled,
.ant-calendar .ant-calendar-ok-btn[disabled] {
  cursor: not-allowed;
}
.ant-calendar .ant-calendar-ok-btn.disabled > *,
.ant-calendar .ant-calendar-ok-btn[disabled] > * {
  pointer-events: none;
}
.ant-calendar .ant-calendar-ok-btn-lg {
  padding: 0 15px;
  font-size: 14px;
  border-radius: 4px;
  height: 32px;
}
.ant-calendar .ant-calendar-ok-btn-sm {
  padding: 0 7px;
  font-size: 12px;
  border-radius: 4px;
  height: 22px;
}
.ant-calendar .ant-calendar-ok-btn > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn > a:only-child:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}
.ant-calendar .ant-calendar-ok-btn:hover,
.ant-calendar .ant-calendar-ok-btn:focus {
  color: #fff;
  background-color: #49a9ee;
  border-color: #49a9ee;
}
.ant-calendar .ant-calendar-ok-btn:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn:focus > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn:hover > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn:focus > a:only-child:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}
.ant-calendar .ant-calendar-ok-btn:active,
.ant-calendar .ant-calendar-ok-btn.active {
  color: #fff;
  background-color: #0e77ca;
  border-color: #0e77ca;
}
.ant-calendar .ant-calendar-ok-btn:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn.active > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn:active > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn.active > a:only-child:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}
.ant-calendar .ant-calendar-ok-btn.disabled,
.ant-calendar .ant-calendar-ok-btn[disabled],
.ant-calendar .ant-calendar-ok-btn.disabled:hover,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover,
.ant-calendar .ant-calendar-ok-btn.disabled:focus,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus,
.ant-calendar .ant-calendar-ok-btn.disabled:active,
.ant-calendar .ant-calendar-ok-btn[disabled]:active,
.ant-calendar .ant-calendar-ok-btn.disabled.active,
.ant-calendar .ant-calendar-ok-btn[disabled].active {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f7f7f7;
  border-color: #d9d9d9;
}
.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child,
.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child,
.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn.disabled > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn[disabled] > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn.disabled:hover > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn[disabled]:hover > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn.disabled:focus > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn[disabled]:focus > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn.disabled:active > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn[disabled]:active > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn.disabled.active > a:only-child:after,
.ant-calendar .ant-calendar-ok-btn[disabled].active > a:only-child:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}
.ant-calendar .ant-calendar-ok-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f7f7f7;
  border-color: #d9d9d9;
  cursor: not-allowed;
}
.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn-disabled > a:only-child:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}
.ant-calendar .ant-calendar-ok-btn-disabled:hover {
  color: rgba(0, 0, 0, 0.25);
  background-color: #f7f7f7;
  border-color: #d9d9d9;
}
.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child {
  color: currentColor;
}
.ant-calendar .ant-calendar-ok-btn-disabled:hover > a:only-child:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: transparent;
}
.ant-calendar-time-picker {
  position: absolute;
  width: 100%;
  top: 34px;
  background-color: #fff;
}
.ant-calendar-time-picker-panel {
  z-index: 1050;
  position: absolute;
  width: 100%;
}
.ant-calendar-time-picker-inner {
  display: inline-block;
  position: relative;
  outline: none;
  list-style: none;
  font-size: 12px;
  text-align: left;
  background-color: #fff;
  background-clip: padding-box;
  line-height: 1.5;
  overflow: hidden;
  width: 100%;
}
.ant-calendar-time-picker-combobox {
  width: 100%;
}
.ant-calendar-time-picker-column-1,
.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {
  width: 100%;
}
.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {
  width: 50%;
}
.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {
  width: 33.33%;
}
.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {
  width: 25%;
}
.ant-calendar-time-picker-input-wrap {
  display: none;
}
.ant-calendar-time-picker-select {
  float: left;
  font-size: 12px;
  border-right: 1px solid #e9e9e9;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  height: 206px;
}
.ant-calendar-time-picker-select:hover {
  overflow-y: auto;
}
.ant-calendar-time-picker-select:first-child {
  border-left: 0;
  margin-left: 0;
}
.ant-calendar-time-picker-select:last-child {
  border-right: 0;
}
.ant-calendar-time-picker-select ul {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  width: 100%;
  max-height: 206px;
}
.ant-calendar-time-picker-select li {
  text-align: center;
  list-style: none;
  box-sizing: content-box;
  margin: 0;
  width: 100%;
  height: 24px;
  line-height: 24px;
  cursor: pointer;
  user-select: none;
  transition: background 0.3s ease;
}
.ant-calendar-time-picker-select li:last-child:after {
  content: '';
  height: 182px;
  display: block;
}
.ant-calendar-time-picker-select li:hover {
  background: #ecf6fd;
}
li.ant-calendar-time-picker-select-option-selected {
  background: #f7f7f7;
  font-weight: bold;
}
li.ant-calendar-time-picker-select-option-disabled {
  color: rgba(0, 0, 0, 0.25);
}
li.ant-calendar-time-picker-select-option-disabled:hover {
  background: transparent;
  cursor: not-allowed;
}
.ant-calendar-time .ant-calendar-day-select {
  padding: 0 2px;
  font-weight: bold;
  display: inline-block;
  color: rgba(0, 0, 0, 0.65);
  line-height: 34px;
}
.ant-calendar-time .ant-calendar-footer {
  position: relative;
  height: auto;
  line-height: auto;
}
.ant-calendar-time .ant-calendar-footer-btn {
  text-align: right;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {
  float: left;
  margin: 0;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {
  display: inline-block;
  margin-right: 8px;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
}
.ant-calendar-time-picker {
  position: absolute;
  width: 100%;
  top: 34px;
  background-color: #fff;
}
.ant-calendar-time-picker-panel {
  z-index: 1050;
  position: absolute;
  width: 100%;
}
.ant-calendar-time-picker-inner {
  display: inline-block;
  position: relative;
  outline: none;
  list-style: none;
  font-size: 12px;
  text-align: left;
  background-color: #fff;
  background-clip: padding-box;
  line-height: 1.5;
  overflow: hidden;
  width: 100%;
}
.ant-calendar-time-picker-combobox {
  width: 100%;
}
.ant-calendar-time-picker-column-1,
.ant-calendar-time-picker-column-1 .ant-calendar-time-picker-select {
  width: 100%;
}
.ant-calendar-time-picker-column-2 .ant-calendar-time-picker-select {
  width: 50%;
}
.ant-calendar-time-picker-column-3 .ant-calendar-time-picker-select {
  width: 33.33%;
}
.ant-calendar-time-picker-column-4 .ant-calendar-time-picker-select {
  width: 25%;
}
.ant-calendar-time-picker-input-wrap {
  display: none;
}
.ant-calendar-time-picker-select {
  float: left;
  font-size: 12px;
  border-right: 1px solid #e9e9e9;
  box-sizing: border-box;
  overflow: hidden;
  position: relative;
  height: 206px;
}
.ant-calendar-time-picker-select:hover {
  overflow-y: auto;
}
.ant-calendar-time-picker-select:first-child {
  border-left: 0;
  margin-left: 0;
}
.ant-calendar-time-picker-select:last-child {
  border-right: 0;
}
.ant-calendar-time-picker-select ul {
  list-style: none;
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  width: 100%;
  max-height: 206px;
}
.ant-calendar-time-picker-select li {
  text-align: center;
  list-style: none;
  box-sizing: content-box;
  margin: 0;
  width: 100%;
  height: 24px;
  line-height: 24px;
  cursor: pointer;
  user-select: none;
  transition: background 0.3s ease;
}
.ant-calendar-time-picker-select li:last-child:after {
  content: '';
  height: 182px;
  display: block;
}
.ant-calendar-time-picker-select li:hover {
  background: #ecf6fd;
}
li.ant-calendar-time-picker-select-option-selected {
  background: #f7f7f7;
  font-weight: bold;
}
li.ant-calendar-time-picker-select-option-disabled {
  color: rgba(0, 0, 0, 0.25);
}
li.ant-calendar-time-picker-select-option-disabled:hover {
  background: transparent;
  cursor: not-allowed;
}
.ant-calendar-time .ant-calendar-day-select {
  padding: 0 2px;
  font-weight: bold;
  display: inline-block;
  color: rgba(0, 0, 0, 0.65);
  line-height: 34px;
}
.ant-calendar-time .ant-calendar-footer {
  position: relative;
  height: auto;
  line-height: auto;
}
.ant-calendar-time .ant-calendar-footer-btn {
  text-align: right;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-today-btn {
  float: left;
  margin: 0;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn {
  display: inline-block;
  margin-right: 8px;
}
.ant-calendar-time .ant-calendar-footer .ant-calendar-time-picker-btn-disabled {
  color: rgba(0, 0, 0, 0.25);
}
.ant-calendar-month-panel {
  position: absolute;
  top: 1px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  border-radius: 4px;
  background: #fff;
  outline: none;
}
.ant-calendar-month-panel > div {
  height: 100%;
}
.ant-calendar-month-panel-hidden {
  display: none;
}
.ant-calendar-month-panel-header {
  height: 34px;
  line-height: 34px;
  text-align: center;
  user-select: none;
  border-bottom: 1px solid #e9e9e9;
}
.ant-calendar-month-panel-header a:hover {
  color: #49a9ee;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select,
.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select,
.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select,
.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select {
  padding: 0 2px;
  font-weight: bold;
  display: inline-block;
  color: rgba(0, 0, 0, 0.65);
  line-height: 34px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-century-select-arrow,
.ant-calendar-month-panel-header .ant-calendar-month-panel-decade-select-arrow,
.ant-calendar-month-panel-header .ant-calendar-month-panel-year-select-arrow,
.ant-calendar-month-panel-header .ant-calendar-month-panel-month-select-arrow {
  display: none;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {
  position: absolute;
  top: 0;
  color: rgba(0, 0, 0, 0.43);
  font-family: Arial, "Hiragino Sans GB", "Microsoft Yahei", "Microsoft Sans Serif", sans-serif;
  padding: 0 5px;
  font-size: 16px;
  display: inline-block;
  line-height: 34px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn {
  left: 7px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-century-btn:after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-decade-btn:after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-year-btn:after {
  content: '«';
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn {
  right: 7px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-century-btn:after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-decade-btn:after,
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-year-btn:after {
  content: '»';
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn {
  left: 29px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-prev-month-btn:after {
  content: '‹';
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn {
  right: 29px;
}
.ant-calendar-month-panel-header .ant-calendar-month-panel-next-month-btn:after {
  content: '›';
}
.ant-calendar-month-panel-body {
  height: calc(100% - 34px);
}
.ant-calendar-month-panel-table {
  table-layout: fixed;
  width: 100%;
  height: 100%;
  border-collapse: separate;
}
.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month {
  background: #108ee9;
  color: #fff;
}
.ant-calendar-month-panel-selected-cell .ant-calendar-month-panel-month:hover {
  background: #108ee9;
  color: #fff;
}
.ant-calendar-month-panel-cell {
  text-align: center;
}
.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month,
.ant-calendar-month-panel-cell-disabled .ant-calendar-month-panel-month:hover {
  cursor: not-allowed;
  color: #bcbcbc;
  background: #f7f7f7;
}
.ant-calendar-month-panel-month {
  display: inline-block;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.65);
  background: transparent;
  text-align: center;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  border-radius: 4px;
  transition: background 0.3s ease;
}
.ant-calendar-month-panel-month:hover {
  background: #ecf6fd;
  cursor: pointer;
}
.ant-calendar-year-panel {
  position: absolute;
  top: 1px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  border-radius: 4px;
  background: #fff;
  outline: none;
}
.ant-calendar-year-panel > div {
  height: 100%;
}
.ant-calendar-year-panel-hidden {
  display: none;
}
.ant-calendar-year-panel-header {
  height: 34px;
  line-height: 34px;
  text-align: center;
  user-select: none;
  border-bottom: 1px solid #e9e9e9;
}
.ant-calendar-year-panel-header a:hover {
  color: #49a9ee;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select,
.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select,
.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select,
.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select {
  padding: 0 2px;
  font-weight: bold;
  display: inline-block;
  color: rgba(0, 0, 0, 0.65);
  line-height: 34px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-century-select-arrow,
.ant-calendar-year-panel-header .ant-calendar-year-panel-decade-select-arrow,
.ant-calendar-year-panel-header .ant-calendar-year-panel-year-select-arrow,
.ant-calendar-year-panel-header .ant-calendar-year-panel-month-select-arrow {
  display: none;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {
  position: absolute;
  top: 0;
  color: rgba(0, 0, 0, 0.43);
  font-family: Arial, "Hiragino Sans GB", "Microsoft Yahei", "Microsoft Sans Serif", sans-serif;
  padding: 0 5px;
  font-size: 16px;
  display: inline-block;
  line-height: 34px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn {
  left: 7px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-century-btn:after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-decade-btn:after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-year-btn:after {
  content: '«';
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn {
  right: 7px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-century-btn:after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-decade-btn:after,
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-year-btn:after {
  content: '»';
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn {
  left: 29px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-prev-month-btn:after {
  content: '‹';
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn {
  right: 29px;
}
.ant-calendar-year-panel-header .ant-calendar-year-panel-next-month-btn:after {
  content: '›';
}
.ant-calendar-year-panel-body {
  height: calc(100% - 34px);
}
.ant-calendar-year-panel-table {
  table-layout: fixed;
  width: 100%;
  height: 100%;
  border-collapse: separate;
}
.ant-calendar-year-panel-cell {
  text-align: center;
}
.ant-calendar-year-panel-year {
  display: inline-block;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.65);
  background: transparent;
  text-align: center;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  border-radius: 4px;
  transition: background 0.3s ease;
}
.ant-calendar-year-panel-year:hover {
  background: #ecf6fd;
  cursor: pointer;
}
.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year {
  background: #108ee9;
  color: #fff;
}
.ant-calendar-year-panel-selected-cell .ant-calendar-year-panel-year:hover {
  background: #108ee9;
  color: #fff;
}
.ant-calendar-year-panel-last-decade-cell .ant-calendar-year-panel-year,
.ant-calendar-year-panel-next-decade-cell .ant-calendar-year-panel-year {
  user-select: none;
  color: rgba(0, 0, 0, 0.25);
}
.ant-calendar-decade-panel {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;
  background: #fff;
  border-radius: 4px;
  outline: none;
}
.ant-calendar-decade-panel-hidden {
  display: none;
}
.ant-calendar-decade-panel-header {
  height: 34px;
  line-height: 34px;
  text-align: center;
  user-select: none;
  border-bottom: 1px solid #e9e9e9;
}
.ant-calendar-decade-panel-header a:hover {
  color: #49a9ee;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select {
  padding: 0 2px;
  font-weight: bold;
  display: inline-block;
  color: rgba(0, 0, 0, 0.65);
  line-height: 34px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-century-select-arrow,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-decade-select-arrow,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-year-select-arrow,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-month-select-arrow {
  display: none;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {
  position: absolute;
  top: 0;
  color: rgba(0, 0, 0, 0.43);
  font-family: Arial, "Hiragino Sans GB", "Microsoft Yahei", "Microsoft Sans Serif", sans-serif;
  padding: 0 5px;
  font-size: 16px;
  display: inline-block;
  line-height: 34px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn {
  left: 7px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-century-btn:after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-decade-btn:after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-year-btn:after {
  content: '«';
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn {
  right: 7px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-century-btn:after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-decade-btn:after,
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-year-btn:after {
  content: '»';
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn {
  left: 29px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-prev-month-btn:after {
  content: '‹';
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn {
  right: 29px;
}
.ant-calendar-decade-panel-header .ant-calendar-decade-panel-next-month-btn:after {
  content: '›';
}
.ant-calendar-decade-panel-body {
  height: calc(100% - 34px);
}
.ant-calendar-decade-panel-table {
  table-layout: fixed;
  width: 100%;
  height: 100%;
  border-collapse: separate;
}
.ant-calendar-decade-panel-cell {
  text-align: center;
  white-space: nowrap;
}
.ant-calendar-decade-panel-decade {
  display: inline-block;
  margin: 0 auto;
  color: rgba(0, 0, 0, 0.65);
  background: transparent;
  text-align: center;
  height: 24px;
  line-height: 24px;
  padding: 0 6px;
  border-radius: 4px;
  transition: background 0.3s ease;
}
.ant-calendar-decade-panel-decade:hover {
  background: #ecf6fd;
  cursor: pointer;
}
.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade {
  background: #108ee9;
  color: #fff;
}
.ant-calendar-decade-panel-selected-cell .ant-calendar-decade-panel-decade:hover {
  background: #108ee9;
  color: #fff;
}
.ant-calendar-decade-panel-last-century-cell .ant-calendar-decade-panel-decade,
.ant-calendar-decade-panel-next-century-cell .ant-calendar-decade-panel-decade {
  user-select: none;
  color: rgba(0, 0, 0, 0.25);
}
.ant-calendar-month .ant-calendar-month-panel,
.ant-calendar-month .ant-calendar-year-panel {
  top: 0;
  height: 248px;
}
nz-datepicker {
  display: inline-block;
  position: relative;
}
.ant-calendar-picker-container {
  position: relative;
  left: -2px;
}
.ant-calendar-picker-container.top {
  bottom: -2px;
}
.ant-calendar-picker-container.bottom {
  top: -2px;
}
.container {
  position: absolute;
  width: 375px;
  z-index: 1001;
  background: #fff;
  border: 1px solid #ddd;
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.175);
  padding: 0 10px;
}
.container .ant-result {
  padding: 10px 0;
  display: flex;
  justify-content: space-between;
}
.container .ant-footer {
  border-top: 1px solid #e9e9e9;
  padding: 5px 0 ;
  display: flex;
}
.container .ant-footer-title {
  font-weight: 900;
  padding-right: 3px;
}
.container .ant-footer-cell {
  padding-right: 2px;
}
.container .ant-footer-cell-title {
  padding-right: 2px;
  color: #aaa;
}
.container .ant-footer-cell-content {
  text-decoration: underline;
  color: #6bb4d6;
  cursor: pointer;
  padding-right: 3px;
}
.ant-container {
  display: flex;
}
.ant-startDate,
.ant-endDate {
  font-weight: bold;
}
.ant-datepicker {
  height: auto!important;
}
.ant-hidden-bg {
  visibility: hidden;
}
.ant-show-bg {
  visibility: visible;
}
.ant-middle-bg {
  width: 15px;
  height: 100%;
  overflow: hidden;
}
.ant-middle-bg .gap-line {
  height: 15px;
  width: 15px;
  position: relative;
}
.ant-middle-bg .gap-line .gap-1 {
  z-index: 1;
  height: 0px;
  border-left: 8px solid #ffffff;
  border-top: 8px solid #eeeeee;
  border-bottom: 8px solid #eeeeee;
}
.ant-middle-bg .gap-line .gap-2 {
  position: absolute;
  right: 0px;
  top: 0px;
  z-index: 2;
  height: 0px;
  border-left: 8px solid transparent;
  border-top: 8px solid #ffffff;
}
.ant-middle-bg .gap-line .gap-3 {
  position: absolute;
  right: 0px;
  top: 8px;
  z-index: 2;
  height: 0px;
  border-left: 8px solid transparent;
  border-bottom: 8px solid #ffffff;
}
.ant-result {
  border-bottom: 1px solid #e9e9e9;
}
.ant-result-header {
  font-size: 14px;
  font-weight: 500;
}
.ant-input {
  position: relative;
  display: inline-block;
  padding: 4px 7px;
  width: 100%;
  height: 28px;
  cursor: text;
  font-size: 12px;
  line-height: 1.5;
  color: rgba(0, 0, 0, 0.65);
  background-color: #fff;
  background-image: none;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  transition: all .3s;
}
.ant-input:focus {
  border-color: #49a9ee;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(16, 142, 233, 0.2);
}
.ant-input-content {
  position: relative;
  display: inline-block;
}
.ant-input-clear {
  position: absolute;
  right: 5px;
  top: 5px;
  cursor: pointer;
}
.ant-input-clear:before {
  display: block;
  font-family: 'anticon';
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  content: "\\E62E";
}
.ant-input-lg .ant-input-default {
  height: 32px!important;
}
.ant-input-lg .ant-input-clear {
  top: 7px;
}
.ant-input-sm .ant-input-default {
  height: 22px!important;
}
.ant-input-sm .ant-input-clear {
  top: 2px;
}
`],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => DaterangepickerComponent),
    multi: true
  }],
  animations: [
    DropDownAnimation,
    TagAnimation
  ],
})
export class DaterangepickerComponent implements OnInit, ControlValueAccessor {
  nextMonth = new Date().setMonth(new Date().getMonth() + 1);
  nowMonth = new Date();
  _showMonth = moment().month();
  _showYear = moment().year();
  _showLastYear =moment().month()==11?moment().year()+1:moment().year();
  _showLastMonth =moment().month()==11?0:moment().month()+1;
  _showMiddleBg = [];
  _startDate = null;
  _endDate = null;
  _shortcuts: object[];
  _customShortcuts: object[];
  _width = '180px';
  _result: string;
  _isRemoveBtn = true;
  _size: string;
  _isDatepickerHide = false;
  _btnType = 'default';
  _placeholder = '请选择...';
  onChange: any = Function.prototype;
  onTouched: any = Function.prototype;
  @Input()
  get antShortcuts() {
    return this._shortcuts;
  }

  set antShortcuts(value: object[]) {
    this._shortcuts = value;
  }
  @Input()
  get antCustomShortcuts() {
    return this._customShortcuts;
  }

  set antCustomShortcuts(value: object[]) {
    this._customShortcuts = value;
  }
  @Input()
  set isDatepickerHide(value: boolean) {
      value = value ? value : false;
      this._isDatepickerHide = value;
  }
  @Input() set antploceholder(value: string) {
    if (value !== undefined) {
      this._placeholder = value;
    }
  }
  @Input()
  set antWidth(value: number) {
    if (value) {
      this._width = value + 'px';
    }
  }
  @Input()
  set antSize(value: string) {
    this._size = { large: 'ant-input-lg', small: 'ant-input-sm' }[ value ];
  }
  @ViewChild('datepickerData') datepickerData: any;
  @ViewChild('datepickerDataLast') datepickerDataLast: any;

  @HostListener('document:click', ['$event'])
  onClick(btn: Event) {
      if (!this._elementRef.nativeElement.contains(event.target)) {
        // 关闭datepicker
        this._isDatepickerHide = false;
      }
  }
  /**
   * 双向绑定，接收数据
   */
  writeValue(value: string) {
    if (value) {
      if (value.indexOf('~') > -1 &&  value.length > 15) {
        let arr = value.split('~');
        const month =  moment(arr[0]).month(),
              year = moment(arr[0]).year(),
              monthLast = moment(arr[1]).month(),
              yearLast = moment(arr[1]).year();
        this._showMonth = month;
        this._showYear = year;
        if (month === monthLast && year === yearLast) {
          // const _month = moment().month();
          // const _year = moment().year();
          this._showLastMonth =this._showMonth==11?0:this._showMonth + 1;
          this._showLastYear =this._showMonth==11?this._showYear+1:this._showYear;
          setTimeout(_ => {
            this._startDate = this.findItemDay(this.datepickerData, moment(arr[0]).format('YYYY-MM-DD'));
            this._endDate = this.findItemDay(this.datepickerData, moment(arr[1]).format('YYYY-MM-DD'));
            this.enterStartAndEnd();
          })
        }else {
          this._showLastMonth = monthLast;
          this._showLastYear = yearLast;
          setTimeout(_ => {
            this._startDate = this.findItemDay(this.datepickerData, moment(arr[0]).format('YYYY-MM-DD'));
            this._endDate = this.findItemDay(this.datepickerDataLast, moment(arr[1]).format('YYYY-MM-DD'));
            this.enterStartAndEnd();
          })
        }
      }
    }else {
      this.remove();
    }
  }
  registerOnChange(fn: (_: any) => {}): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: () => {}): void {
    this.onTouched = fn;
  }
  constructor(
    private _elementRef: ElementRef,
    private _renderer: Renderer2
  ) { }
  ngOnInit() {
    // this._shortcuts = [
    //   {
    //     title: '过去',
    //     tag: 'prev',
    //     datas: [1, 3, 5, 7]
    //   },
    //   {
    //     title: '将来',
    //     tag: 'next',
    //     datas: [1, 3, 9]
    //   }
    // ];
  //   this._customShortcuts = [{
  //     name: '这个月',
  //     dates : [moment().startOf('month').toDate(), moment().endOf('month').toDate()]
  // }, {
  //     name: '上个月',
  //     dates : [
  //             moment().subtract(1, 'month').startOf('month').toDate(),
  //             moment().subtract(1, 'month').endOf('month').toDate()
  //         ]
  // }];
  }
  _preMonth() {
    if (this._showMonth - 1 < 0) {
      this._showMonth = 11;
      this._preYear();
    } else {
      this._showMonth = this._showMonth - 1;
    }
    setTimeout(_ => {
      this.showStartAndEnd();
    })
  }

  _nextMonth() {
    if (this._showMonth + 1 > 11) {
      this._showMonth = 0;
      this._nextYear();
    } else {
      this._showMonth = this._showMonth + 1;
    }
    setTimeout(_ => {
      this.showStartAndEnd();
    })
  }
  _preYear() {
    this._showYear = this._showYear - 1;
  }

  _nextYear() {
    this._showYear = this._showYear + 1;
  }
  _preLastMonth() {
    if (this._showLastMonth - 1 < 0) {
      this._showLastMonth = 11;
      this._preLastYear();
    } else {
      this._showLastMonth = this._showLastMonth - 1;
    }
    setTimeout(_ => {
      this.showStartAndEnd();
    })
  }

  _nextLastMonth() {
    if (this._showLastMonth + 1 > 11) {
      this._showLastMonth = 0;
      this._nextLastYear();
    } else {
      this._showLastMonth = this._showLastMonth + 1;
    }
    setTimeout(_ => {
      this.showStartAndEnd();
    })
  }
  _preLastYear() {
    this._showLastYear = this._showLastYear - 1;
  }

  _nextLastYear() {
    this._showLastYear = this._showLastYear + 1;
  }

  //
  clickDay(data) {
    if (!data.day.isSelectedDay) {
      data.day.isSelectedDay = true;
    }
    if (!this.isEmptyObject(this._startDate)) {
      this._startDate = data.day;
      this._endDate = {title: '...'};
      // this._result = '';
      // this.onChange('');
      return;
    }
    if (this.isEmptyObject(this._startDate) && !this.isEmptyObject(this._endDate)) {
      if (this._startDate['title'] > data.day['title']) {
        this._endDate = this._startDate;
        this._startDate = data.day;
      }else {
        this._endDate = data.day;
      }
      this._result = `${this._startDate['title']}~${this._endDate['title']}`;
      this._btnType = 'primary';
      this.onChange(this._result);
      return;
    }
    this.resetDatepicker(this.datepickerData);
    this.resetDatepicker(this.datepickerDataLast);
    this._startDate = data.day;
    data.day.isSelectedDay = true;
    this._endDate = {title: '...'};
    // this._result = '';
    // this.onChange('');
  }
  // // 中间横栏
  // middleBg() {
  //   for (let i = 0; i < 12; i++) {
  //     this._showMiddleBg.push(
  //       `<div class="gap-line">
  //         <div class="gap-1"></div>
  //         <div class="gap-2"></div>
  //         <div class="gap-3"></div>
  //       </div>`)
  //   }
  // }

  /**
   * 鼠标移入
   */
  mouseDay(data) {
    if (this.isEmptyObject(this._startDate) && !this.isEmptyObject(this._endDate)) {
      this.isMiddleDay(this.datepickerData._weeksCalendar, data.day);
      this.isMiddleDay(this.datepickerDataLast._weeksCalendar, data.day);
    }
  }
  isMiddleDay(array, day) {
    array.forEach(element => {
        element.days.forEach(item => {
          if (item.title > this._startDate['title']) {
            if ( item.title <= day.title) {
              item.isMiddleDay = true;
              item.distanceStartDay = this.DateDiff(this._startDate['title'], item.title);
            }else {
              item.isMiddleDay = false;
            }
            return;
          }
          if (item.title < this._startDate['title']) {
            if ( item.title >= day.title) {
              item.isMiddleDay = true;
              item.distanceStartDay = this.DateDiff(this._startDate['title'], item.title);
            }else {
              item.isMiddleDay = false;
            }
          }
        });
      })
  }
  // 显示start and end
  showStartAndEnd() {
   if (this.isEmptyObject(this._startDate)) {
    this.showSelected(this.datepickerData);
    this.showSelected(this.datepickerDataLast);
   }
   if (this.isEmptyObject(this._endDate)) {
    this.showSelected(this.datepickerData, true);
    this.showSelected(this.datepickerDataLast, true);
   }
  }
  // 计算天数差的函数，通用
  DateDiff(sDate1: string,  sDate2: string): number {    // sDate1和sDate2是2006-12-18格式
    if (!sDate2) {
      return;
    }
      let  aDate,  oDate1,  oDate2,  iDays;
      aDate  =  sDate1.split('-');
      oDate1  =  new  Date(`${aDate[1]}-${aDate[2]}-${aDate[0]}`)    // 转换为12-18-2006格式
      aDate  =  sDate2.split('-');
      oDate2  =  new  Date(`${aDate[1]}-${aDate[2]}-${aDate[0]}`)
      iDays  =  parseInt(String(Math.abs(oDate1  -  oDate2) / 1000 / 60 / 60 / 24) , 10);
      return  iDays + 1
  }
  // 对象是否为空
  isEmptyObject(object: object):boolean {
    if (object === null) {
      return false
    }
    return object.hasOwnProperty('isSelectedDay')
  }
  // 显示选中
  showSelected(obj: object, isMiddle?: boolean) {
    const _this = this;
    obj['_weeksCalendar'].forEach(element => {
      element.days.forEach(item => {
        if (_this._startDate['title'] === item.title && !item.isLastMonth && !item.isNextMonth) {
          item.isSelectedDay = true;
        }
        if (isMiddle) {
          if (_this._endDate['title'] === item.title && !item.isLastMonth && !item.isNextMonth) {
            item.isSelectedDay = true;
          }
          if (_this._startDate['title'] < item.title && _this._endDate['title'] > item.title) {
            item.isMiddleDay = true;
          }
        }
      })
    })
  }
  // 重置
  resetDatepicker(obj: object) {
    obj['_weeksCalendar'].forEach(element => {
      element.days.forEach(item => {
        item.isMiddleDay = false;
        item.isSelectedDay = false;
      })
    })
  }
  // 快捷选择
  shortcutOption(day: number | object, tag?: string) {
    let arrDate = [];
    this.resetDatepicker(this.datepickerData);
    this.resetDatepicker(this.datepickerDataLast);
    if (typeof day === 'number') {
      this.assignStartEndDay(day, tag);
    }
    if (typeof day === 'object') {
      arrDate = day['dates'];
      const _month = moment(arrDate[0]).month();
      const _year = moment(arrDate[0]).year();
      const _monthLast = moment(arrDate[1]).month();
      const _yearLast = moment(arrDate[1]).year();
      this._showMonth = _month;
      this._showYear = _year;
      if (_month ===  _monthLast && _year === _yearLast) {
        this._showLastMonth = _month == 11? 0:_month+1;
        this._showLastYear = _month == 11?_year+1:_year;
        
        setTimeout(_ => {
            this._startDate = this.findItemDay(this.datepickerData, moment(arrDate[0]).format('YYYY-MM-DD'));
            this._endDate = this.findItemDay(this.datepickerData, moment(arrDate[1]).format('YYYY-MM-DD'));
            this.enterStartAndEnd();
            this.onChange(this._result);
        })
        return;
      }
      this._showLastMonth = _monthLast;
      this._showLastYear = _yearLast;
      
      setTimeout(_ => {
        this._startDate = this.findItemDay(this.datepickerData, moment(arrDate[0]).format('YYYY-MM-DD'));
        this._endDate = this.findItemDay(this.datepickerDataLast, moment(arrDate[1]).format('YYYY-MM-DD'));
        this.enterStartAndEnd();
        this.onChange(this._result);
      })
    }
  }
  // 查找
  findItemDay(obj: object, day: string): any {
    let result;
    obj['_weeksCalendar'].forEach(element => {
      element.days.forEach(item => {
        if (day === item.title) {
          result = item;
          return;
        }
      })
    })
    return result;
  }
  // 排列start and end 顺序
  sortStartEndDay(start: object, end: object) {
    if (start['title'] > end['title']) {
      this._startDate = end;
      this._endDate = start;
    }
  }
  // 赋值开始时间和结束时间
  assignStartEndDay(day: number, tag: string) {
    let _startDays, _endDays;
    if (tag === 'prev') {
      _startDays = moment(moment().subtract(day, 'days')).format('YYYY-MM-DD');
      _endDays = moment(moment().subtract(1, 'days')).format('YYYY-MM-DD');
    }
    if ( tag === 'next' ) {
      _startDays = moment(moment().add(1, 'days')).format('YYYY-MM-DD');
      _endDays = moment(moment().add(day, 'days')).format('YYYY-MM-DD');
    }
    let _month = moment(_startDays).month(),
        _year = moment(_startDays).year(),
        _monthLast = moment(_endDays).month(),
        _yearLast = moment(_endDays).year();
        this._showMonth = _month;
        this._showYear = _year;
    if (_month === _monthLast && _year === _yearLast ) {
      this._showLastMonth = _month == 11? 0:_month+1;
      this._showLastYear = _month == 11?_year+1:_year;
    }else {
      this._showLastMonth = _monthLast;
      this._showLastYear = _yearLast;
    }
    setTimeout(_ => {
      this._startDate = this.findItemDay(this.datepickerData, _startDays);
      this._endDate = this.findItemDay(this.datepickerData, _endDays) || this.findItemDay(this.datepickerDataLast, _endDays);
      this.enterStartAndEnd();
      this.onChange(this._result);
    })
  }
  // 删除
  remove() {
    this._isRemoveBtn = true;
    this._btnType = 'default';
    this._result = '';
    this._startDate = null;
    this._endDate = null;
    if (this._isDatepickerHide) {
      this.resetDatepicker(this.datepickerData);
      this.resetDatepicker(this.datepickerDataLast);
    }
    this.onChange('');
  }
  // 初始化
  init() {
    this._isDatepickerHide = !this._isDatepickerHide;
    if(this._startDate){
      return false;
    }
    if (!this._result) {
      this.resetDatepicker(this.datepickerData);
      this.resetDatepicker(this.datepickerDataLast);
    }
  }
  // 确认
  confirmBtn() {
    this._isDatepickerHide = false;
  }
  // 悬浮
  removeBtn() {
    if (this._result) {
      this._isRemoveBtn = false;
    }
  }
  //
  enterStartAndEnd() {
    this.resetDatepicker(this.datepickerData);
    this.resetDatepicker(this.datepickerDataLast);
    this.sortStartEndDay(this._startDate, this._endDate);
    this.showStartAndEnd();
    this._result = `${this._startDate['title']}~${this._endDate['title']}`;
    this._btnType = 'primary';
  }
}
